/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export enum EstatePeriod {
  PREVIOUS_MONTH = 0,
  CURRENT_MONTH = 1,
  RANGE = 13,
}
